import*as e from"react";const s=e.createContext({dismissed:!1,setDismissed:()=>{}}),t=()=>e.useContext(s);export{s as MessageContext,t as useMessage};
